import { render } from "./HeroiconsOutlineDocumentAdd.vue?vue&type=template&id=25af8ba7"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentAdd.vue"]])

export default __exports__